import {useEffect} from "react";
import {PositionOptions} from "../types/common";

export function useLockBodyScroll(active: boolean) {
    useEffect(() => {
        if (!active) return;

        const {overflow} = document.documentElement.style;
        document.documentElement.style.overflow = "hidden !important";
        return () => {
            document.documentElement.style.overflow = overflow;
        };
    }, [active]);
}

export const throttle = function (func: (...args: any) => void, delay: number) {
    let lastCall = 0;
    return function (...args: any) {
        const now = new Date().getTime()
        if ((now - lastCall) < delay) {
            return;
        }
        lastCall = now;
        func(...args)
    }
}

export const computeOverlayPositioning = (triggerEl: HTMLElement,
                                          overlayEl: HTMLElement,
                                          options: PositionOptions = {}): React.CSSProperties => {
    const {placement, offset = 8, fitToScreenOnMobile, isMobile, portal} = options;
    if (fitToScreenOnMobile && isMobile) {
        return {
            position: "static",
            overflow: "scroll",
            transform: "none",
            zIndex: 9999,
            width: "auto",
            maxWidth: "inherit",
            borderRadius: 0,
            height: "auto",
            bottom: "14px",
            background: "transparent"
        }
    }
    if (!overlayEl || !triggerEl) return {};
    const rect = triggerEl.getBoundingClientRect();
    const cRect = overlayEl.getBoundingClientRect();
    let top = 0, left = 0;
    switch (placement) {
        case "top":
            top = rect.top - cRect.height - offset;
            left = rect.left + (rect.width - cRect.width) / 2;
            break;
        case "bottom":
            top = rect.top + cRect.height + offset;
            left = rect.left + (rect.width - cRect.width) / 2;
            break;
        case "left":
            top = rect.top + (rect.height - cRect.height) / 2;
            left = rect.left - cRect.width - 1;
            break
        case "right":
            top = rect.top + rect.height / 2 - cRect.height / 2;
            left = rect.right + offset;
            break;
        default:
            if (cRect.height >= (window.innerHeight - rect.bottom)) {
                top = rect.top - cRect.height - offset;
                left = rect.left;
            } else {
                top = rect.bottom + offset;
                left = rect.left;
            }
            break
    }
    return {
        position: portal ? "fixed" : "absolute",
        top,
        left,
        overflow: "auto",
        transform: "scale(1)",
        zIndex: 99,
        transformOrigin: "center top 0px",
        width: rect.width,
    }
}

export const formatCurrency = (val:string)=>{
    if(!val) return
    return `₦${val}`
}